
import { Outlet } from 'react-router-dom';
import './index.css'
function PageContent() {
return (
     <div className="PageContent">
    
   <Outlet/>
</div>
);
}
export default PageContent